/*eslint complexity: off*/
import React, {
  useContext,
  useEffect,
  useState
}                           from 'react';
import { useTranslation }   from 'react-i18next';
import DescriptionIcon    from '@material-ui/icons/Description';
import {
  files,
  createFile,
  editFile,
}                           from '~/config/routes';
import { toast }            from 'react-toastify';
import { historyPropType }  from '~/config/routerPropTypes';
import Request              from '~/providers/Request';
import Context              from './context';
import Paper                from '~/components/Paper';
import ModalDelete          from '~/components/ModalDelete';
import InputShow            from '~/components/InputShow';
import PaperButtons         from '~/components/PaperButtons';
import FileRecord      from '~/records/FileRecord';
import GridContainer        from '~/components/GridContainer';
import GridItem             from '~/components/GridItem';
import { AbilityContext }   from '~/contexts/Can';

const attrName = (attr) => FileRecord.hummanAttributeName(attr);

function ShowFile({history}) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [ record, setRecord ] = useState(new FileRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord(record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/files/${id}`, {})
      .then( response => {
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete(){
    setLoading(true);
    Request.del(`/admin/files/${id}`)
    .then(() => {
      toast.success(t('delete-toast-success'));
      history.push(files.spec);
    })
    .catch(() => {
      setLoading(false);
      toast.error(t('delete-toast-fail'));
    });
    setModal(false);
  }

  return (
    <Paper
      Icon={ DescriptionIcon }
      iconColor="blue"
      title={t('files.defSingular')}
      loading={ loading }
      actions={
        <PaperButtons
          id={ id }
          setModal={ability.can('delete', 'Specialties') ? setModal : null}
          backRoute={ files }
          newRoute={ability.can('new', 'Specialties') ? createFile : null}
          editRoute={ability.can('edit', 'Specialties') ? editFile : null}
        />}
      >
          <GridContainer>
            <GridItem xs={5} md={5}>
              <InputShow
                label={attrName('url')}
                value={record.get('url')}
              />
            </GridItem>
            <GridItem xs={3} md={3}>
              <InputShow
                label={attrName('key')}
                value={record.get('key') ? t(`${record.get('key')}`) : null}
              />
            </GridItem>
            {/* <GridItem xs={3} md={3}>
              <InputShow
                label={attrName('pack_type')}
                value={record.get('pack_type') ? t(`addon.type.${record.get('pack_type')}`) : null}
              />
            </GridItem> */}
            {/* <GridItem xs={1} md={1}>
              <InputShow
                label={attrName('order')}
                value={record.get('order')}
              />
            </GridItem> */}
            <GridItem xs={1} md={1}>
              <InputShow
                label={attrName('is_active')}
                value={record.get('is_active') }
                type='boolean'
              />
            </GridItem>
          </GridContainer>
        <ModalDelete
          modal={modal}
          onClose={() => {
            setModal(false);
          }}
          name={record.get('name')}
          id={record.get('id')}
          deleteAction={handleDelete}
        />
      </Paper>
  );
}

  ShowFile.propTypes={
    history: historyPropType,
  };

export default ShowFile;
